<!--
Author: liyuqin
Date: 2025-5-19
Desc: 银行卡短信认证弹框
 -->
<template>
    <div class="comp-img-code comp">
        <el-dialog
            title="手机认证"
            :visible.sync="visible"
            width="800px"
            class="prop"
            v-on:close="dialogClose"
        >
            <div style="display: flex; align-items: center">
                <img src="@/assets/img/msg.png" width="70" style="margin-right: 60px" alt="" />
                <el-form
                    ref="form"
                    label-width="200px"
                    :model="form"
                    :rules="ruleVerify"
                    class="form-contain"
                    v-on:submit.native.prevent
                >
                    <el-form-item label="您的手机号码：">
                        <div style="display: flex">
                            <div style="width: 180px">
                                {{
                                    bankInfo.newMobile
                                        ? $util.maskPhoneNumber(bankInfo.newMobile)
                                        : $util.maskPhoneNumber(bankInfo.mobileno)
                                }}
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item label="请输入短信验证码：" prop="smscode">
                        <div style="display: flex; justify-items: center">
                            <el-input
                                v-model.trim="form.smscode"
                                :maxlength="$cache.getSysParam('10103006')"
                                placeholder="请输入短信验证码"
                            />
                            <el-button
                                style="margin-left: 30px"
                                :class="time > 0 ? 'get-verify-disabled' : 'get-verify'"
                                v-on:click="sendSms"
                            >
                                {{ btnMsg }}
                            </el-button>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <el-form slot="footer" class="dialog-footer">
                <el-button class="cancelBtn" v-on:click="dialogClose">取 消</el-button>
                <el-button class="confirmBtn" v-on:click="submitForm()">确 定</el-button>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
import userApi from "@/api/user";

export default {
    name: "BankSmsValid",
    props: {
        dialogVisible: {
            type: Boolean,
            required: true
        },
        acctInfo: {
            type: Object,
            required: true
        },
        bankInfo: {
            type: Object,
            required: true
        },
        biztype: {
            // 01-用来认证找回密码
            // 02-用于银行卡激活
            // 03-开户绑卡
            type: String,
            required: true
        },
        enMobileno: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            form: {
                mobileno: "",
                smscode: ""
            },
            visible: false, // 是否显示dialog
            ruleVerify: {
                smscode: [{ validator: this.$util.validateVerifyCode, trigger: "blur" }]
            },
            time: 0,
            btnMsg: "获取验证码"
        };
    },
    watch: {
        dialogVisible(val) {
            this.visible = val;
            this.$refs["form"].resetFields();
        }
    },
    methods: {
        validateField(key) {
            let flag = false;
            this.$refs["form"].validateField([key], (valid) => {
                if (valid) {
                    this.$message({
                        type: "error",
                        message: valid
                    });
                } else {
                    flag = true;
                }
            });
            return flag;
        },
        sendSms() {
            if (this.time > 0) return;
            let param = {
                biztype: this.biztype,
                en_custname: this.acctInfo.en_custname,
                certificatetype: this.acctInfo.certificatetype,
                en_certificateno: this.acctInfo.en_certificateno,
                channelid: this.bankInfo.channelid,
                en_depositcard: this.bankInfo.en_desendepositcard
            };
            if (
                this.$util.isEmpty(this.bankInfo.newMobile) ||
                this.bankInfo.newMobile === this.bankInfo.mobileno
            ) {
                param["en_mobileno"] = this.bankInfo.en_mobileno;
            } else {
                param["mobileno"] = this.bankInfo.newMobile;
            }
            userApi.sendBindCardSms(param, true).then((res) => {
                if (res.code === "0") {
                    /* 倒计时 */
                    this.time = res.data.sendperiod;
                    this.$util.btnDisabled(this);
                } else {
                    this.$message({
                        type: "warning",
                        message: res.msg
                    });
                }
            });
        },
        async submitForm() {
            if (this.time === 0) {
                this.$message({
                    type: "error",
                    message: "请先获取验证码"
                });
                return;
            }
            if (!this.validateField("smscode")) {
                return;
            }
            const param = {
                biztype: this.biztype,
                smscode: this.form.smscode
            };
            if (
                this.$util.isEmpty(this.bankInfo.newMobile) ||
                this.bankInfo.newMobile === this.bankInfo.mobileno
            ) {
                param["en_mobileno"] = this.bankInfo.en_mobileno;
            } else {
                param["mobileno"] = this.bankInfo.newMobile;
            }
            userApi.checkBindCardSms(param, true).then((res) => {
                if (res.code === "0") {
                    this.$emit("sms-comfirm");
                    this.dialogClose();
                } else {
                    this.$message({
                        type: "warning",
                        message: res.msg
                    });
                }
            });
        },
        dialogClose() {
            this.$emit("close");
            this.form = {
                mobileno: "",
                smscode: ""
            };
            this.time = 0;
            this.btnMsg = "获取验证码";
            this.$util.btnDisabled(this);
        }
    }
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/varibles";
.comp-img-code {
    background: #ffffff;

    .cancelBtn {
        width: 180px;
        height: 42px;
        border-radius: 2px;
        background: #e4e4e4;
        font-size: 16px;
        font-weight: 500;
        color: #666666;
        border: 1px solid #e4e4e4;
        cursor: pointer;
    }

    .confirmBtn {
        width: 180px;
        height: 42px;
        border-radius: 2px;
        background: var(--color-primary);
        color: #ffffff;
        font-size: 16px;
        font-weight: 500;
        border: 1px solid var(--color-primary);
        cursor: pointer;
    }

    :deep(.el-input__inner) {
        width: 180px;
    }

    :deep(.el-dialog__header) {
        height: 40px;
        border-radius: 6px 6px 0px 0px;
        box-sizing: border-box;
        position: relative;
        padding: 0 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .el-dialog__headerbtn {
            position: relative;
            width: 19.99px;
            height: 19.99px;
            background: #ffffff;
            border: 1px solid #999999;
            box-sizing: border-box;
        }

        .el-dialog__headerbtn:hover {
            border: 1px solid var(--color-primary);
        }

        .el-icon-close {
            color: #999999;
        }

        .el-icon-close:before {
            color: #999999;
            font-size: 18px;
        }

        .el-icon-close:hover:before {
            color: var(--color-primary) !important;
        }
    }
    :deep(.el-dialog__body) {
        padding: 20px 40px;
    }
    :deep(.el-form-item__error) {
        display: none;
    }
    .get-verify {
        color: $bg18;
        cursor: pointer;
    }
    .get-verify-disabled {
        color: $text-color3;
        cursor: not-allowed;
        background: #ffffff;
    }
}
</style>
